// extracted by mini-css-extract-plugin
export var parcelRow = "_q6-0";